import React from "react";
import { CheckCircle, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { assets } from "../../assets/assets";

export default function SignInSuccessScreen() {
    return (
        <main className="relative min-h-screen bg-[#F8FAFC] flex items-center justify-center overflow-hidden">

            {/* Top Logo */}
            <div className="absolute top-6 left-6 sm:top-8 sm:left-8">
                <Link
                    to="/"
                    className="flex items-center gap-3"
                >
                    <img
                        src={assets.k_Solution_logo}
                        alt="K Solution"
                        className="h-12 w-12 rounded-xl object-contain"
                    />

                    <span className="text-xl font-bold text-[#062B63]">
                        K Solution
                    </span>
                </Link>
            </div>


            {/* Decorative Menu */}
            <button
                type="button"
                aria-label="Open menu"
                className="
                    absolute
                    top-7
                    right-7
                    sm:top-8
                    sm:right-8
                    text-[#062B63]
                    transition
                    duration-300
                    hover:text-[#FFC400]
                "
            >
                <span className="text-3xl">☰</span>
            </button>


            {/* Main Card */}
            <div className="w-full max-w-lg px-6">

                <div
                    className="
                        rounded-2xl
                        border
                        border-gray-200
                        bg-white
                        px-8
                        py-12
                        text-center
                        shadow-xl
                        sm:px-12
                    "
                >

                    {/* Success Icon */}
                    <div className="flex justify-center">
                        <div
                            className="
                                flex
                                h-20
                                w-20
                                items-center
                                justify-center
                                rounded-full
                                bg-[#E8F5E9]
                            "
                        >
                            <CheckCircle
                                size={48}
                                strokeWidth={1.8}
                                className="text-green-600"
                            />
                        </div>
                    </div>


                    {/* Heading */}
                    <h1
                        className="
                            mt-7
                            text-3xl
                            font-bold
                            tracking-tight
                            text-[#062B63]
                            sm:text-4xl
                        "
                    >
                        Sign In Successful
                    </h1>


                    {/* Description */}
                    <p
                        className="
                            mx-auto
                            mt-4
                            max-w-md
                            text-base
                            leading-7
                            text-gray-500
                        "
                    >
                        Welcome back to K Solution. Your account has been
                        successfully authenticated.
                    </p>


                    {/* Yellow Accent */}
                    <div className="mx-auto mt-7 h-1 w-16 rounded-full bg-[#FFC400]" />


                    {/* Continue Button */}
                    <Link
                        to="/"
                        className="
                            mt-8
                            inline-flex
                            w-full
                            items-center
                            justify-center
                            gap-3
                            rounded-lg
                            bg-[#062B63]
                            px-6
                            py-3.5
                            font-semibold
                            text-white
                            transition-all
                            duration-300
                            hover:bg-[#0A3A7A]
                            hover:shadow-lg
                        "
                    >
                        Continue to Dashboard

                        <ArrowRight
                            size={19}
                            strokeWidth={2.5}
                        />
                    </Link>

                </div>


                {/* Footer */}
                <p className="mt-6 text-center text-xs text-gray-400">
                    K Solution · Construction Management Platform
                </p>

            </div>

        </main>
    );
}